import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  hidePassword = true;
  hideConfirmPassword = true;
  email = '';

  constructor(
    private router: Router,
    private toastrService: ToastrService,
    private appService: AppService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((res: any) => {
      if (res.code) {
        let code = this.appService.decrypt(res.code, 'Forgot Password Salt');
        this.email = code.split('**')[0];
        let time = code.split('**')[1];
        let currentTime = new Date().getTime();
        if (currentTime - parseInt(time) > 24 * 60 * 60 * 1000) {
          this.toastrService.error('Link Expired', 'Please try again');
          this.router.navigate(['login']);
          return;
        }
      }
    });
  }

  ngOnInit() {
    this.resetPasswordForm = new FormGroup(
      {
        newPassword: new FormControl(null, [
          Validators.required,
          Validators.minLength(8),
        ]),
        confirmPassword: new FormControl(null, [Validators.required,Validators.minLength(8)]),
      },
      { validators: this.passwordMatchValidator }
    );
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  toggleConfirmPasswordVisibility() {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }

  onResetPassword() {
    if (this.resetPasswordForm.valid) {
      const newPassword = this.resetPasswordForm.get('newPassword')?.value;
      this.appService.hashPassword(newPassword).then((hashedPassword: string) => {
        const body = {
          email: this.email,
          password: hashedPassword,
        };
        this.appService.resetPassword(this.email, body).subscribe(
          () => {
            this.toastrService.success(
              'Password reset successfully',
              'Success'
            );
            this.router.navigate(['/login']);
          },
          (error) => {
            this.toastrService.error(
              'Failed to reset password',
              'Error'
            );
          }
        );
      });
    } else {
      this.toastrService.warning(
        'Please fill out the form correctly',
        'Password Mismatch'
      );
    }
  }
}